import type { LabelHTMLAttributes, ReactNode } from 'react';

import { cnm } from 'utils/classNames';

import LabelText from './LabelText';

interface Props extends LabelHTMLAttributes<HTMLLabelElement> {
	children: ReactNode;
	className?: string;
	disabled?: boolean;
	htmlFor: string;
	invalid?: boolean;
	isHidden?: boolean;
	required?: boolean;
	valid?: boolean;
}

/** A regular form field label. */
export default function InlineLabel({
	children,
	className,
	disabled = false,
	htmlFor,
	invalid = false,
	isHidden = false,
	required = false,
	valid = false,
}: Props) {
	return (
		<label
			htmlFor={htmlFor}
			className={cnm(
				'inline-block',
				isHidden && 'sr-only',

				// Color
				invalid && 'text-error',
				valid && 'text-success',
				disabled && 'text-disabled',

				className,
			)}
		>
			<LabelText required={required}>{children}</LabelText>
		</label>
	);
}
InlineLabel.displayName = 'InlineLabel';
